import Axios from 'axios';
import { browserName, fullBrowserVersion, mobileModel, mobileVendor, osName, osVersion } from 'react-device-detect';

export const getConfigDeviceAndLocationData = async () => {
    const deviceData = {
        osVersion: osVersion,
        osName: osName,
        fullBrowserVersion: fullBrowserVersion,
        browserName: browserName,
        mobileVendor: mobileVendor,
        mobileModel: mobileModel,
    };

    if (localStorage.getItem('configDeviceAndLocationData')) {
        return JSON.parse(localStorage.getItem('configDeviceAndLocationData'));
    }
    try {
        const res = await Axios.get('https://geolocation-db.com/json/', { timeout: 1000 });
        const dataUserDto = {
            ipv4: res.data.IPv4,
            countryName: res.data.country_name,
            countryCode: res.data.country_code,
            state: res.data.state,
            city: res.data.city,
            ...deviceData,
        };
        localStorage.setItem('configDeviceAndLocationData', JSON.stringify(dataUserDto));
        return dataUserDto;
    } catch (e) {
        const dataUserDto = localStorage.getItem('configDeviceAndLocationData')
            ? JSON.parse(localStorage.getItem('configDeviceAndLocationData'))
            : {};
        return { ...dataUserDto, ...deviceData };
    }
};
